export default {
  alt: 'Selecionar idioma',
  en: {
    alt: 'Inglês',
    title: 'Inglês',
  },
  es: {
    alt: 'Espanhol',
    title: 'Espanhol',
  },
  close: {
    alt: 'Fechar',
  },
  ko: {
    alt: 'Coreano',
    title: 'Coreano',
  },
  zh: {
    alt: 'Chinês',
    title: 'Chinês',
  },
  vi: {
    alt: 'Vietnamita',
    title: 'Vietnamita',
  },
  ru: {
    alt: 'Russo',
    title: 'Russo',
  },
  'pt-PT': {
    alt: 'Português (Portugal)',
    title: 'Português (Portugal)',
  },
  'pt-BR': {
    alt: 'Português (Brasil)',
    title: 'Português (Brasil)',
  },
}
